/* eslint-disable no-use-before-define */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { all, call, put, select, takeLeading } from 'redux-saga/effects'
import type { RootState } from 'state/store'

import Api from '@/api/_legacy'
import { ApiClient, ApiNote } from '@/api/_legacy/generated-api'
import { createLogoutExtraReducers } from '@/utilities/redux'

// TODO...
const TENANT_ID = 'absa'

export interface NoteSearchState {
  clients: ApiClient[]
  currentBusinessUnits: Array<any>
  filteredNotes: ApiNote[]
  notes: ApiNote[]
  searchTerm: string
  selectedBusinessUnitId: string
  selectedClient: ApiClient
  selectedClientId: string
  tenant: string
}

const initialState: NoteSearchState = {
  clients: [],
  selectedClientId: '',
  selectedBusinessUnitId: '',
  selectedClient: undefined,
  currentBusinessUnits: [],
  notes: [],
  filteredNotes: [],
  tenant: '',
  searchTerm: ''
}

export const noteSearchSlice = createSlice({
  name: 'noteSearch',
  initialState,
  reducers: {
    init: () => {
      // state.note.client = undefined;
    },
    setClient: (state, action: PayloadAction<string>) => {
      const client = state.clients.find(x => x.clientId === action.payload)

      if (!client) {
        state.selectedClientId = undefined
        state.selectedClient = undefined
        state.currentBusinessUnits = []
        state.filteredNotes = [...state.notes]
        return state
      }

      state.selectedClientId = client.clientId
      state.selectedClient = client
      state.currentBusinessUnits = client.businessUnits

      state.filteredNotes = state.notes.filter(filterNote(state))
    },
    setBusinessUnit: (state, action: PayloadAction<string>) => {
      const businessUnit = state.selectedClient?.businessUnits?.find(
        x => x.businessUnitId === action.payload
      )

      state.selectedBusinessUnitId = businessUnit?.businessUnitId
      state.filteredNotes = state.notes.filter(filterNote(state))
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload
      state.filteredNotes = state.notes.filter(filterNote(state))
    },
    fetchClientsSuccess: (state, action: PayloadAction<ApiClient[]>) => {
      state.clients = action.payload
    },
    fetchNotesSuccess: (state, action: PayloadAction<ApiNote[]>) => {
      state.notes = action.payload
      state.filteredNotes = action.payload
    }
  },
  extraReducers: builder => {
    const logoutReducers = createLogoutExtraReducers(initialState)
    Object.entries(logoutReducers).forEach(([actionType, reducer]) => {
      builder.addCase(actionType, reducer)
    })
  }
})

export const { actions } = noteSearchSlice

export type NoteSearchActions = typeof actions

const filterNote = (state: NoteSearchState) => (note: ApiNote) =>
  (note.businessUnitId === state.selectedBusinessUnitId ||
    (state.selectedBusinessUnitId === '' &&
      state.currentBusinessUnits?.find(bu => bu.businessUnitId === note.businessUnitId)) ||
    state.selectedClientId === '') &&
  note.noteName.toLowerCase().indexOf(state.searchTerm?.toLocaleLowerCase()) >= 0

function* fetchClientsSaga() {
  const state: RootState = yield select()
  const { userType } = state.builder
  if (userType === 'admin' || userType === 'absa') {
    try {
      const response = yield call(Api.tenant.clientDetail, TENANT_ID)
      yield put({
        type: 'noteSearch/fetchClientsSuccess',
        payload: response.data
      })
    } catch (error) {
      yield put({ type: 'noteSearch/fetchClientsFailure', payload: error })
    }
  }
}

function* fetchNotesSaga() {
  const state: RootState = yield select()
  const { userType } = state.builder
  if (userType === 'admin' || userType === 'absa') {
    try {
      const response = yield call(Api.tenant.noteDetail, TENANT_ID)
      yield put({ type: 'noteSearch/fetchNotesSuccess', payload: response.data })
    } catch (error) {
      yield put({ type: 'noteSearch/fetchNotesFailure', payload: error })
    }
  } else {
    try {
      const currentUserResponse = yield call(Api.usermanager.currentList)
      const { businessUnitId } = currentUserResponse.data.clients[0].businessUnits[0]
      const response = yield call(Api.tenant.businessunitDetail2, businessUnitId, TENANT_ID)
      yield put({ type: 'noteSearch/fetchNotesSuccess', payload: response.data })
    } catch (error) {
      yield put({ type: 'noteSearch/fetchNotesFailure', payload: error })
    }
  }
}

function* fetchReferenceDataSaga() {
  yield all([fetchClientsSaga(), fetchNotesSaga()])
}

export function* noteSearchSaga() {
  yield all([takeLeading('noteSearch/init', fetchReferenceDataSaga)])
}

export default noteSearchSlice.reducer
